
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gif-maker",
      function () {
        return require("private-next-pages/gif-maker/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gif-maker"])
      });
    }
  